import * as React from "react";

function SvgShuffle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 20"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M18.11 6.11h1.11v3.37L24 4.74 19.21 0v2.81h-1.1C13.68 2.81 11.18 6 9 8.88c-2 2.55-3.69 4.76-6.46 4.76H0v3.3h2.51c4.43 0 6.93-3.22 9.14-6.07 1.98-2.55 3.69-4.76 6.46-4.76zM6.49 8.18c.19-.23.38-.48.57-.73.47-.6 1-1.24 1.51-1.88a8.7 8.7 0 00-6.06-2.52H0v3.29h2.51a5.62 5.62 0 013.98 1.84zm12.72 5.7h-1.1a5.79 5.79 0 01-4.19-2.05l-.36.47c-.53.68-1.1 1.41-1.73 2.14a8.8 8.8 0 006.28 2.74h1.1V20L24 15.26l-4.79-4.74z" />
    </svg>
  );
}

const MemoSvgShuffle = React.memo(SvgShuffle);
export default MemoSvgShuffle;
